import React from "react";
import clsx from "clsx";
import { FeatureConfig } from "../../../config/marketing/features";
import { MEDIA_MAP } from "../../../components/marketing/media";

const COL_SPAN_MAP: Record<number, string> = {
    1: "lg:col-span-1",
    2: "lg:col-span-2",
    3: "lg:col-span-3",
    4: "lg:col-span-4",
    5: "lg:col-span-5",
    6: "lg:col-span-6",
    7: "lg:col-span-7",
    8: "lg:col-span-8",
    9: "lg:col-span-9",
    10: "lg:col-span-10"
};

interface FeatureRowProps {
    feature: FeatureConfig;
    reverse?: boolean;
}

export default function FeatureRow({ feature, reverse }: FeatureRowProps) {
    const Icon = feature.icon;
    const MediaComponent = MEDIA_MAP[feature.media];

    return (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-10 items-center mx-auto my-auto w-full rounded-xl lg:rounded-none shadow-lg lg:shadow-none">
            {/* Text */}
            <div
                className={clsx(
                    COL_SPAN_MAP[feature.layout.text],
                    reverse && "lg:order-2",
                    "md:px-8 px-4 py-4 md:py-0 flex flex-col items-center justify-center w-full min-h-72"
                )}
            >
                <div className="flex items-center gap-2 text-xl text-text-muted w-full">
                    <Icon className="h-4 tracking-tight w-4 text-primary" />
                    <span>{feature.kicker}</span>
                </div>
                <h3 className="mt-3 text-2xl md:text-3xl  tracking-tight font-semibold text-text-primary w-full">{feature.title}</h3>
                <p className="mt-4 text-lg md:text-xl leading-relaxed text-text-secondary tracking-tight w-full">
                    {feature.description}
                </p>
            </div>

            {/* Media */}
            <div className={clsx(COL_SPAN_MAP[feature.layout.media], reverse && "lg:order-1 w-full")}>
                <div>
                    <MediaComponent />
                </div>
            </div>
        </div>
    );
}
